export default __webpack_public_path__ + "static/media/mustard-yellow-1-designify.97b1f889.png";